import React, { useContext, useEffect, useState, useRef } from "react";
import Loader from "react-loader-spinner";

import { Formik } from "formik";
import Cards from "react-credit-cards";
import "react-credit-cards/es/styles-compiled.css";
import ReactHtmlParser from "react-html-parser";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import MaskedInput from "react-text-mask";
import * as Yup from "yup";
import { FiZap, FiCreditCard, FiDollarSign, FiRepeat, FiFileText } from "react-icons/fi";
import BuyStepsTemplate from "../../components/BuyStepsTemplate";
import CartItemsModal from "../../components/CartItemsModal";
import CollapseList from "../../components/CollapseList";
import FreeShippingProgress from "../../components/FreeShippingProgress";
import OrderMinimumNotice from "../../components/OrderMinimumNotice";
import { faltaParaPedidoMinimo } from "../../util/orderMinimum";
import ModalConfirm from "../../components/ModalConfirm";
import PartlyFulfilledOrderModal from "../../components/PartlyFulfilledOrderModal";
import ShowDeliverySelectedStoreModal from "../../components/ShowDeliverySelectedStoreModal";
import ShowDeliveryStoreModal from "../../components/ShowDeliveryStoreModal";
import ShowOpeningHours from "../../components/ShowOpeningHours";
import SubHeader from "../../components/SubHeader";
import Breadcrumb from "../../components/Breadcrumb";
import api from "../../services/api";
import HelmetCustom from "../../components/HelmetCustom";
import { LoadingOverlayContext } from "../../contexts/LoadingOverlayContext";
import { Creators as OrderActions } from "../../store/ducks/order";
import { selectFarmaciaManual } from "../../store/ducks/storeByUser";
import { Creators as UserActions } from "../../store/ducks/user";
import { Creators as CouponActions } from "../../store/ducks/coupon";
import {
  formatCVC,
  formatCreditCardNumber,
  formatExpirationDate,
} from "../../util/cardUtils";
import { formatPrice, textoQuantidadeProdutos } from "../../util/format";
import { ContentWrap, PriceInfoWrap, TitleWrap, Wrap } from "../Cart/styles";
import {
  ButtonFooterWrap,
  CheckoutPage,
  Container,
  CreditCard,
  ErrorContainer,
  FieldErrorMessage,
  CouponErrorMessage,
  Form,
  FormGroup,
  IconBadge,
  Image,
  InputField,
  Label,
  PaymentContainer,
  PaymentDetails,
  PriceInfoContent,
  RadioConteinerGroup,
  Tabs,
  RadioSelectPayment,
  StyledCouponInput,
  DivBadgeStyled,
  OnlinePaymentMinimumNote,
} from "./styles";
import { phoneMask } from "../../util/mask";
import { LoadingOverlay } from "../../components/LoadingOverlay";
import { DeliverySubtype } from "../../util/deliveryType";
import DeliveryOptionExchangeModal from "../../components/DeliveryOptionExchangeModal";
import BadgePaymentProvider from "../../components/BadgePaymentProvider";
import { getExtractProductsCart, getPromotionsSubtotal, getPromotionsTotal } from "../../util/price";

const NOMES_PAGAMENTO = {
  PI: "PIX",
  CR: "Cartão de Crédito",
  DI: "Dinheiro",
  CD: "Cartão de Débito",
  CE: "Crediário",
  CV: "Convênio",
};

export default function CheckoutPayment({ history }) {
  const { setLoadingOverlay } = useContext(LoadingOverlayContext);

  useEffect(() => {
    setLoadingOverlay(false);
  }, [setLoadingOverlay]);

  const dispatch = useDispatch();
  const {
    showConfirmOrderModal,
    orderConfirmationMessage,
    customerAcceptOrder,
  } = useSelector((state) => state.order);
  const { error: couponError, coupon } = useSelector((state) => state.coupon);
  // Farmacia escolhida pelo cliente. O checkout usa este objeto inteiro --
  // tempo_contingencia_gam, horarios, id -- e a farmacia resolvida pelo contexto de
  // entrega tem so id e uuid.
  const store = useSelector(selectFarmaciaManual);
  const storeData = useSelector((state) => state.store.data);
  const { data: basket } = useSelector((state) => state.cart);
  const [buttonText, setButtonText] = useState("");
  const [installments, setInstallments] = useState({});
  const [optionsInstallments, setOptionsInstallments] = useState([]);
  const [paymentMode, setPaymentMode] = useState("");
  const [defaultValueInstallment, setDefaultValueInstallment] = useState(null);

  const [loadingButtonText, setLoadingButtonText] = useState("");
  const [focus, setFocus] = useState("");
  const [abrirPopup, setAddModalOpen] = useState(false);
  const [pagarComCartao, setCreditCardPayment] = useState(false);
  const [address, setAddress] = useState("");
  const [deliveryData, setDeliveryData] = useState(null);
  const [deliveryMultiplicationFactor, setDeliveryMultiplicationFactor] =
    useState(1);
  const inputCouponRef = useRef(null);
  const [showCouponError, setShowCouponError] = useState(null);
  const couponPreloadedRef = useRef(false);
  const prevPaymentModeRef = useRef(paymentMode);

  const cart = useSelector((state) => state.cart);

  const { programa_fidelidade = false } = useSelector((state) =>
    state.user.profile == null ? false : state.user.profile
  );

  const [promotions, setPromotions] = useState([]);
  const [distinctProductsIdCount, setDistinctProductsIdCount] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [regraFreteGratis, setRegraFreteGratis] = useState(null);

  useEffect(() => {
    // A loja chega depois do primeiro render: a resposta da busca anterior (sem loja = regra geral)
    // não pode sobrescrever a da loja selecionada, como já é feito na cesta.
    let ativo = true;
    const lojaId = deliveryData?.lojaSelecionada?.id;
    api
      .get("/stores/free-shipping-rules", { params: lojaId ? { lojaId } : {} })
      .then((response) => {
        if (ativo) setRegraFreteGratis(response.data);
      })
      .catch(() => {
        if (ativo) setRegraFreteGratis({ ativo: false });
      });
    return () => {
      ativo = false;
    };
  }, [deliveryData?.lojaSelecionada?.id]);

  useEffect(() => {
    if (cart.data && cart.data.itens)
      loadPromotions(cart.data.itens, programa_fidelidade);
  }, [cart, programa_fidelidade]);

  const loadPromotions = (items, customerHasFacilityProgram) => {
    const extract = getExtractProductsCart(items, customerHasFacilityProgram);
    setPromotions(extract.promotions);
    setDistinctProductsIdCount(extract.distinctProductsIdCount);
    const subtotal = getPromotionsSubtotal(extract.promotions);
    setSubtotal(subtotal);
    const total = getPromotionsTotal(extract.promotions);
    setTotal(total);
  }


  const handleClose = () => {
    setAddModalOpen(false);
  };

  const handleUseCreditcard = (e) => {
    setCreditCardPayment(true);
    setPaymentMode("");
  };

  const handleDontUseCreditcard = (e) => {
    setCreditCardPayment(false);
    setPaymentMode("");
  };

  const getPagamentoSelecionado = () => {
    const formas = pagarComCartao
      ? deliveryData?.lojaSelecionada?.formaPagamento?.online
      : deliveryData?.lojaSelecionada?.formaPagamento?.presencial;
    return formas?.find((item) => item.tipo === paymentMode);
  };

  const getDescontoPagamento = () => {
    const perc = Number(getPagamentoSelecionado()?.perc_desconto) || 0;
    if (perc <= 0) return 0;
    // mesma conta do backend: arredonda o valor do desconto em centavos
    const baseCents = Math.round((Number(total) || 0) * 100);
    return Math.round((baseCents * perc) / 100) / 100;
  };

  // Nova D1: base após desconto de pagamento e cupom de produto (cupom F desconta frete, não entra na base)
  const descontoCupomMercadoria =
    coupon?.data?.tipo_aplicacao === "F" ? 0 : Number(couponDiscount) || 0;
  const baseFreteGratis = Math.max(
    0,
    (Number(total) || 0) - getDescontoPagamento() - descontoCupomMercadoria
  );
  const freteGratisAplicado = (() => {
    if (!regraFreteGratis?.ativo) return false;
    if (deliveryData?.tipoEntrega !== "RECEBER_EM_CASA") return false;
    const expressaCoberta =
      deliveryData?.subtipoEntrega !== DeliverySubtype.EXPRESSA ||
      !!regraFreteGratis.incluiExpressa;
    const valorMinimo = parseFloat(regraFreteGratis.valorMinimo) || 0;
    return expressaCoberta && baseFreteGratis >= valorMinimo;
  })();

  const verifyCoupon = (cupom) => {
    if (cupom !== "") {
      const pagamentoSelecionado = getPagamentoSelecionado();

      dispatch(
        CouponActions.getCouponRequest({
          cupom,
          amount: total,
          valorFrete: getDeliveryValue(deliveryData),
          carrinho: basket,
          tipoEntrega: deliveryData.tipoEntrega,
          percDescontoPagamento: pagamentoSelecionado?.perc_desconto,
          storeId: deliveryData?.lojaSelecionada?.id,
        })
      );
      setShowCouponError(null);
    } else {
      dispatch(CouponActions.clearCoupon());
    }
  };

  const calculateCouponDiscount = () => {
    if (coupon !== null) {
      if (coupon.data.tipo_aplicacao === "F" && freteGratisAplicado) {
        inputCouponRef.current.triggerResetInput();
        setShowCouponError(
          "O frete é grátis, o cupom não poderá ser utilizado"
        );
        setCouponDiscount(0);
        // Sem limpar o cupom guardado, ele segue no pedido e o servidor recusa a compra.
        dispatch(CouponActions.clearCoupon());
        return;
      }

      // D6: a base do mínimo e do percentual desconta o desconto da forma de pagamento
      const baseCalculo = Math.max(
        0,
        (Number(total) || 0) - getDescontoPagamento()
      );

      if (coupon.data.valor_min_aplicacao > baseCalculo) {
        inputCouponRef.current.triggerResetInput();
        const msg =
          "Este cupom só é válido para compras acima de: R$" +
          parseFloat(coupon.data.valor_min_aplicacao)
            ?.toFixed(2)
            ?.replace(".", ",");
        setShowCouponError(msg);
        setCouponDiscount(0);
        dispatch(CouponActions.clearCoupon());
        return;
      }

      let valorDesconto = 0;
      if (coupon.data.tipo_desconto === "D") {
        if (coupon.data.tipo_aplicacao === "F") {
          const shippingCost = getDeliveryTotal(deliveryData);
          valorDesconto = shippingCost >= coupon.data.valor_desconto ? coupon.data.valor_desconto : shippingCost;
        } else {
          valorDesconto = coupon.data.valor_desconto;
        }

      } else {
        if (coupon.data.tipo_aplicacao === "F") {
          if (deliveryData !== null && deliveryData.lojaSelecionada !== null) {
            valorDesconto =
              getDeliveryTotal(deliveryData) *
              (coupon.data.valor_desconto / 100);
          }
        } else {
          valorDesconto = baseCalculo * (coupon.data.valor_desconto / 100);
        }
      }

      if (valorDesconto > coupon.data.valor_max_aplicacao)
        valorDesconto = coupon.data.valor_max_aplicacao;

      setCouponDiscount(valorDesconto);
    }
  };

  // O servidor só marca freteManualVendaAssistida quando a loja e o endereço são os
  // combinados na venda assistida — a mesma regra usada na cobrança do pedido.
  const hasAssistedSaleManualFreight = (deliveryData) =>
    deliveryData?.lojaSelecionada?.freteManualVendaAssistida === true &&
    basket?.valorFreteInformado !== null &&
    basket?.valorFreteInformado !== undefined;

  // Frete manual é cobrado uma vez só, mesmo em pedido dividido (OrderController.createOrder).
  const getDeliveryTotal = (deliveryData) =>
    getDeliveryValue(deliveryData) *
    (hasAssistedSaleManualFreight(deliveryData) ? 1 : deliveryMultiplicationFactor);

  const getDeliveryValue = (deliveryData) => {
    if (hasAssistedSaleManualFreight(deliveryData)) {
      return Number(basket.valorFreteInformado)
    }
    return deliveryData && deliveryData.subtipoEntrega === DeliverySubtype.EXPRESSA && deliveryData.lojaSelecionada.local_entrega && deliveryData.lojaSelecionada.local_entrega.permite_entrega_expressa ? deliveryData.lojaSelecionada.local_entrega.custo_entrega_expressa : (deliveryData?.lojaSelecionada?.local_entrega?.custo_entrega ?? deliveryData?.lojaSelecionada?.custo_entrega)
  };

  // Pedido mínimo: produtos com o cupom de produto (sem frete e sem o desconto da forma de pagamento), como a api
  const valorMinimoPedido = Number(installments.valor_minimo_pedido) || 0;
  const baseMinimoPedido = (Number(total) || 0) - descontoCupomMercadoria;
  const abaixoPedidoMinimo = faltaParaPedidoMinimo(baseMinimoPedido, valorMinimoPedido) > 0;
  // Piso do provedor: total cobrado sem o desconto da forma de pagamento
  const pisoPagamentoOnline = Number(installments.valor_minimo_pagamento_online) || 0;
  const abaixoPisoOnline = () =>
    pisoPagamentoOnline > 0 && calculateTotal() + getDescontoPagamento() < pisoPagamentoOnline;

  const calculateTotal = () => {
    let valorEntrega = 0;
    if (
      deliveryData?.lojaSelecionada !== null &&
      deliveryData?.tipoEntrega === "RECEBER_EM_CASA" &&
      !freteGratisAplicado
    ) {
      valorEntrega = parseFloat(getDeliveryTotal(deliveryData));
    }
    return total + valorEntrega - couponDiscount - getDescontoPagamento();
  };

  const { message: errorMessage, loading } = useSelector(
    (state) => state.order
  );

  useEffect(() => {
    if (basket && basket.cupom && basket.cupom.nome && deliveryData && !couponPreloadedRef.current) {
      couponPreloadedRef.current = true;
      dispatch(CouponActions.getCouponRequest({
        cupom: basket.cupom.nome,
        amount: total,
        valorFrete: getDeliveryValue(deliveryData),
        carrinho: basket,
        tipoEntrega: deliveryData.tipoEntrega,
        percDescontoPagamento: 0,
        storeId: deliveryData?.lojaSelecionada?.id,
      }));
    } else if (!basket?.cupom && !couponPreloadedRef.current) {
      couponPreloadedRef.current = true;
      dispatch(CouponActions.clearCoupon());
    }
    dispatch(UserActions.updateRewardsProgram());

    return () => {
      dispatch(OrderActions.resetError());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deliveryData]);

  useEffect(() => {
    if (couponError !== null && showCouponError === null) {
      if (inputCouponRef?.current) {
        inputCouponRef.current.triggerResetInput();
        setShowCouponError(couponError);
      }
    }
  }, [couponError, showCouponError]);

  useEffect(() => {
    if (paymentMode && paymentMode !== prevPaymentModeRef.current && coupon?.data?.nome) {
      verifyCoupon(coupon.data.nome);
    }
    prevPaymentModeRef.current = paymentMode;
  }, [paymentMode, dispatch, pagarComCartao, total, deliveryData])

  const CreditCardSchema = Yup.object().shape({
    cvc: Yup.string().when("paymentMode", {
      is: (paymentMode) => paymentMode === "CR",
      then: Yup.string().required("CVV não pode ser vazio"),
    }),
    expiry: Yup.string().when("paymentMode", {
      is: (paymentMode) => paymentMode === "CR",
      then: Yup.string().required("Data de validade não pode ser vazio"),
    }),
    name: Yup.string().when("paymentMode", {
      is: (paymentMode) => paymentMode === "CR",
      then: Yup.string()
        .matches(
          /[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ]/,
          "Nome deve conter apenas letras"
        )
        .required("Nome não pode ser vazio"),
    }),
    number: Yup.string().when("paymentMode", {
      is: (paymentMode) => paymentMode === "CR",
      then: Yup.string().required("Número do cartão não pode ser vazio"),
    }),
  });

  const PaymentSchema = Yup.object().shape({
    paymentMode: Yup.string().required(
      "Escolha uma forma de pagamento para poder finalizar o pedido"
    ),
    paymentValue: Yup.string().when("paymentMode", {
      is: (paymentMode) => paymentMode === "DI",
      then: Yup.string()
        .matches(
          /R[$]\W[1-9]/,
          "Informe um valor válido a ser pago em dinheiro"
        )
        .required("Informe o valor a ser pago em dinheiro"),
      otherwise: Yup.string(),
    }),
    clientNameCE: Yup.string().when("paymentMode", {
      is: (paymentMode) => paymentMode === "CE",
      then: Yup.string()
        .required("Informe o nome e o sobrenome do cliente")
        .matches(
          /[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ]/,
          "Informe um nome de cliente válido"
        )
        .matches(
          /[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ]{3}/,
          "Informe um nome de cliente válido"
        )
        .min(3, "O nome do cliente deve conter pelo menos 3 caracteres"),
      otherwise: Yup.string(),
    }),
    phoneCE: Yup.string().when("paymentMode", {
      is: (paymentMode) => paymentMode === "CE",
      then: Yup.string()
        .required("Informe o número do telefone")
        .matches(
          /^\([1-9]{2}\)\W(?:[2-8]|9[1-9])[0-9]{3}\-[0-9]{4}$/,
          "Informe um número de telefone válido"
        ),
      otherwise: Yup.string(),
    }),
    companyName: Yup.string().when("paymentMode", {
      is: (paymentMode) => paymentMode === "CV",
      then: Yup.string()
        .required("Informe o nome da empresa do convênio")
        .matches(
          /[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ]/,
          "Informe um nome de cliente válido"
        )
        .matches(
          /[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ]{3}/,
          "Informe um nome de cliente válido"
        )
        .min(
          3,
          "O nome da empresa do convênio deve conter pelo menos 3 caracteres"
        ),
      otherwise: Yup.string(),
    }),
    clientNameCV: Yup.string().when("paymentMode", {
      is: (paymentMode) => paymentMode === "CV",
      then: Yup.string()
        .required("Informe o nome completo do cliente")
        .matches(
          /[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ]/,
          "Informe um nome de cliente válido"
        )
        .matches(
          /[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ]{3}/,
          "Informe um nome de cliente válido"
        )
        .min(3, "O nome do cliente deve conter pelo menos 3 caracteres"),
      otherwise: Yup.string(),
    }),
    phoneCV: Yup.string().when("paymentMode", {
      is: (paymentMode) => paymentMode === "CV",
      then: Yup.string()
        .required("Informe o número do telefone")
        .matches(
          /^\([1-9]{2}\)\W(?:[2-8]|9[1-9])[0-9]{3}\-[0-9]{4}$/,
          "Informe um número de telefone válido"
        ),
      otherwise: Yup.string(),
    }),
  });

  useEffect(() => {
    const { dadosEntrega } = localStorage.getItem("@ConexaoGAM:checkout")
      ? JSON.parse(localStorage.getItem("@ConexaoGAM:checkout"))
      : { dadosEntrega: { tipoEntrega: "RECEBER_EM_CASA" } };

    if (deliveryData) {
      if (
        deliveryData.lojaSelecionada !== null ||
        dadosEntrega.tipoEntrega === "RETIRAR_NA_LOJA"
      ) {
        setButtonText("FINALIZAR PEDIDO");
        setLoadingButtonText("FINALIZANDO PEDIDO...");
      }
    } else {
      if (customerAcceptOrder) {
        setButtonText("FINALIZAR PEDIDO");
        setLoadingButtonText("FINALIZANDO PEDIDO...");
      } else {
        setButtonText("PROSSEGUIR");
        setLoadingButtonText("ESCOLHENDO LOJA PARA ENTREGA...");
      }
    }
  }, [customerAcceptOrder, deliveryData, loading, store]);

  useEffect(() => {
    loadScreenByStorage();    
  }, []);

  useEffect(() => {
    if (coupon !== null) {
      calculateCouponDiscount();
    } else {
      setCouponDiscount(0);
    }
  }, [calculateCouponDiscount, coupon]);

  function handleInputFocus(e) {
    setFocus(e.target.name);
  }

  useEffect(() => {
    api.get("/companies/parcelamento").then((response) => {
      setInstallments(response.data);
    });
  }, []);

  useEffect(() => {
    if (total) {
      const orderTotal = calculateTotal();
      const installmentLimit = Number(installments.limite_parcelamento) || 1;
      const minimumOrderValue = Number(installments.valor_minimo_parcelamento) || 0;
      // Cada parcela (2x ou mais) respeita a parcela mínima da empresa e o piso do provedor (decisão 0017)
      const minimumInstallmentValue = Math.max(
        Number(installments.valor_minimo_parcela) || 0,
        Number(installments.valor_minimo_pagamento_online) || 0
      );
      const maximumByInstallmentValue = minimumInstallmentValue > 0
        ? Math.floor(orderTotal / minimumInstallmentValue)
        : installmentLimit;
      const maximumAvailable = orderTotal >= minimumOrderValue
        ? Math.max(1, Math.min(maximumByInstallmentValue, installmentLimit))
        : 1;
      const installmentOptions = [];

      for (let i = 1; i <= maximumAvailable; i++) {
        installmentOptions.push({
          value: `${i}`,
          label: `${i}x de ${formatPrice((orderTotal / i).toFixed(2))}`,
        });
      }

      setDefaultValueInstallment(installmentOptions[0]);
      setOptionsInstallments(installmentOptions);
    }
  }, [
    total,
    deliveryData,
    installments.limite_parcelamento,
    installments.valor_minimo_parcelamento,
    installments.valor_minimo_parcela,
    store,
    deliveryMultiplicationFactor,
    couponDiscount,
    regraFreteGratis,
    paymentMode,
    pagarComCartao,
  ]);

  useEffect(() => {
    if (promotions.length === 0) {
      // history;
    }
  }, [promotions.length, history]);

  const loadScreenByStorage = () => {
    setAddress(address);
    setCreditCardPayment(true);
    loadDeliveryData();
  };

  const loadDeliveryData = () => {
    const { dadosEntrega } = JSON.parse(localStorage.getItem("@ConexaoGAM:checkout")) || {};
    setDeliveryData(dadosEntrega);
    // R34: o frete só é dividido quando o pedido realmente vira par (escolha do cliente
    // + itens a vir do GAM). Fluxos antigos não gravaram possuiItensGam → comportamento antigo.
    const vaiDividir =
      dadosEntrega?.possuiItensGam !== undefined
        ? dadosEntrega.possuiItensGam
        : dadosEntrega?.receberEmDiasDiferentes;
    if (vaiDividir) {
      setDeliveryMultiplicationFactor(2);
    } else {
      setDeliveryMultiplicationFactor(1);
    }
  };


  return (
    <BuyStepsTemplate step={3} history={history}>
      <HelmetCustom pageTitle="Checkout / Pagamento" />
      <CheckoutPage>
        <Breadcrumb
          items={[
            { name: "Cesta de compras" },
            { name: "Revisão do pedido" },
            { name: "Forma de pagamento" },
          ]}
          jsonLd={false}
        />
        <SubHeader title="Forma de pagamento" />
        <PartlyFulfilledOrderModal />
        <DeliveryOptionExchangeModal actionOnExchange={loadDeliveryData} />
        <CartItemsModal isOpen={abrirPopup} handleClose={handleClose} />
        <ShowDeliveryStoreModal />
        <ShowOpeningHours />
        <ShowDeliverySelectedStoreModal />

        {errorMessage !== null && (
          <ErrorContainer>
            {ReactHtmlParser(errorMessage) ||
              "Ops! Ocorreu um erro ao finalizar seu pedido. Tente novamente!"}
          </ErrorContainer>
        )}
        <Container>
          <ContentWrap>
            <Wrap>
              <PaymentContainer>
                <Tabs>
                  {deliveryData?.lojaSelecionada?.formaPagamento.online.length >
                    0 && (
                      <>
                        <Image
                          id="pagamento-online"
                          onClick={handleUseCreditcard}
                        >
                          <span className={pagarComCartao ? "selected" : ""}>
                            Pagar Online
                          </span>
                        </Image>
                      </>
                    )}
                  {deliveryData?.lojaSelecionada?.formaPagamento.presencial
                    .length > 0 && (
                      <>
                        <Image
                          id="pagamento-local"
                          onClick={handleDontUseCreditcard}
                        >
                          <span className={pagarComCartao ? "" : "selected"}>
                            Pagar na{" "}
                            {deliveryData?.tipoEntrega === "RECEBER_EM_CASA"
                              ? "Entrega"
                              : "Farmácia"}
                          </span>
                        </Image>
                      </>
                    )}
                </Tabs>
                <PaymentDetails>
                  {(pagarComCartao ||
                    deliveryData?.lojaSelecionada?.formaPagamento.presencial
                      .length === 0) &&
                    deliveryData?.lojaSelecionada?.formaPagamento.online
                      .length > 0 && (
                      <>
                        <Formik
                          initialValues={{
                            cvc: "",
                            expiry: "",
                            name: "",
                            number: "",
                            installments: "1",
                            paymentMode: "",
                            paymentPlace: "O",
                          }}
                          validate={(values) => { }}
                          validationSchema={CreditCardSchema}
                          onSubmit={(values) => {
                            dispatch(OrderActions.orderRequest(values));
                          }}
                        >
                          {({
                            values,
                            handleChange,
                            handleBlur,
                            errors,
                            touched,
                            handleSubmit,
                            setFieldValue,
                            handleReset,
                            isSubmitting,
                            isValid,
                          }) =>
                            deliveryData && (
                              <>
                                <Form id="payment-form" onSubmit={handleSubmit}>
                                  {abaixoPisoOnline() ? (
                                    <OnlinePaymentMinimumNote>
                                      O valor mínimo de compra para pagamento online é de {formatPrice(pisoPagamentoOnline)}. Escolha pagar na{" "}
                                      {deliveryData?.tipoEntrega === "RECEBER_EM_CASA" ? "entrega" : "farmácia"}.
                                    </OnlinePaymentMinimumNote>
                                  ) : (
                                  <RadioConteinerGroup>
                                    {deliveryData?.lojaSelecionada?.formaPagamento.online.map(
                                      (payment) => (
                                        <div key={payment.tipo}>
                                          {payment.tipo === "PI" && (
                                            <>
                                              <div
                                                key={`O-${payment.tipo}`}
                                                id="pagamento-pix"
                                                className={
                                                  values.paymentMode === "PI"
                                                    ? "radio selected"
                                                    : "radio"
                                                }
                                              >
                                                <RadioSelectPayment>
                                                  <input
                                                    className=""
                                                    id="radio-1"
                                                    value="PI"
                                                    onChange={(e) => {
                                                      handleReset();
                                                      handleChange(e);
                                                      setPaymentMode("PI");
                                                      setFieldValue(
                                                        "paymentPercDiscount",
                                                        payment.perc_desconto
                                                      );
                                                    }}
                                                    onBlur={handleBlur}
                                                    name="paymentMode"
                                                    type="radio"
                                                    checked={
                                                      values.paymentMode ===
                                                        "PI"
                                                        ? true
                                                        : false
                                                    }
                                                  />
                                                  <label
                                                    htmlFor="radio-1"
                                                    className="radio-label"
                                                  >
                                                    <IconBadge><FiZap size={18} /></IconBadge>
                                                    PIX
                                                  </label>
                                                  {Number(payment.perc_desconto) > 0 && (
                                                      <label className="labelDiscount">
                                                        {payment.perc_desconto}{" "}
                                                        % de desconto
                                                      </label>
                                                    )}
                                                </RadioSelectPayment>
                                              </div>
                                            </>
                                          )}
                                          {payment.tipo === "CR" && (
                                            <>
                                              <div
                                                key={`O-${payment.tipo}`}
                                                id="pagamento-credito"
                                                className={
                                                  values.paymentMode === "CR"
                                                    ? "radio selected"
                                                    : "radio"
                                                }
                                              >
                                                <RadioSelectPayment>
                                                  <input
                                                    id="radio-2"
                                                    value="CR"
                                                    onChange={(e) => {
                                                      handleReset();
                                                      handleChange(e);
                                                      setPaymentMode("CR");
                                                      setFieldValue(
                                                        "paymentPercDiscount",
                                                        payment.perc_desconto
                                                      );
                                                    }}
                                                    onBlur={handleBlur}
                                                    name="paymentMode"
                                                    type="radio"
                                                    checked={
                                                      values.paymentMode ===
                                                        "CR"
                                                        ? true
                                                        : false
                                                    }
                                                  />
                                                  <label
                                                    htmlFor="radio-2"
                                                    className="radio-label"
                                                  >
                                                    <IconBadge><FiCreditCard size={18} /></IconBadge>
                                                    Cartão de Crédito
                                                  </label>
                                                  {Number(payment.perc_desconto) > 0 && (
                                                      <label className="labelDiscount">
                                                        {payment.perc_desconto}{" "}
                                                        % de desconto
                                                      </label>
                                                    )}
                                                </RadioSelectPayment>
                                                {values.paymentMode ===
                                                  "CR" && (
                                                    <>
                                                      <div
                                                        className={`payment-form-type pag-card`}
                                                      >
                                                        <h1>
                                                          Informe os dados do seu
                                                          cartão
                                                        </h1>
                                                        <CreditCard>
                                                          <Cards
                                                            locale={{
                                                              valid: "validade",
                                                            }}
                                                            placeholders={{
                                                              name: "SEU NOME AQUI",
                                                            }}
                                                            cvc={values.cvc}
                                                            expiry={values.expiry}
                                                            name={values.name}
                                                            focused={focus}
                                                            onFocus={
                                                              handleInputFocus
                                                            }
                                                            number={values.number}
                                                          />
                                                        </CreditCard>
                                                        <FormGroup>
                                                          {errors.number &&
                                                            touched.number ? (
                                                            <FieldErrorMessage>
                                                              {errors.number}
                                                            </FieldErrorMessage>
                                                          ) : null}

                                                          <InputField
                                                            invalid={
                                                              pagarComCartao &&
                                                              errors.number &&
                                                              touched.number
                                                            }
                                                            id="number"
                                                            type="text"
                                                            name="number"
                                                            onChange={(e) =>
                                                              setFieldValue(
                                                                "number",
                                                                formatCreditCardNumber(
                                                                  e.target.value
                                                                )
                                                              )
                                                            }
                                                            onBlur={handleBlur}
                                                            onFocus={
                                                              handleInputFocus
                                                            }
                                                            value={values.number}
                                                            placeholder="Número do cartão"
                                                            width={"300px"}
                                                          />
                                                          <Label>
                                                            Número do cartão
                                                          </Label>
                                                        </FormGroup>
                                                        <div className="cardGroup">
                                                          <FormGroup>
                                                            {errors.name &&
                                                              touched.name ? (
                                                              <FieldErrorMessage>
                                                                {errors.name}
                                                              </FieldErrorMessage>
                                                            ) : null}

                                                            <InputField
                                                              invalid={
                                                                pagarComCartao &&
                                                                errors.name &&
                                                                touched.name
                                                              }
                                                              id="name"
                                                              type="text"
                                                              name="name"
                                                              onChange={
                                                                handleChange
                                                              }
                                                              onBlur={handleBlur}
                                                              onFocus={
                                                                handleInputFocus
                                                              }
                                                              value={values.name}
                                                              placeholder="Nome do titular"
                                                            />
                                                            <Label>
                                                              Nome impresso no
                                                              cartão
                                                            </Label>
                                                          </FormGroup>
                                                          <FormGroup className="menorCampo">
                                                            {errors.expiry &&
                                                              touched.expiry ? (
                                                              <FieldErrorMessage className="segundaCol">
                                                                {errors.expiry}
                                                              </FieldErrorMessage>
                                                            ) : null}

                                                            <InputField
                                                              invalid={
                                                                pagarComCartao &&
                                                                errors.expiry &&
                                                                touched.expiry
                                                              }
                                                              id="expiry"
                                                              type="text"
                                                              name="expiry"
                                                              onBlur={handleBlur}
                                                              onFocus={
                                                                handleInputFocus
                                                              }
                                                              value={
                                                                values.expiry
                                                              }
                                                              className="segundaCol"
                                                              onChange={(e) =>
                                                                setFieldValue(
                                                                  "expiry",
                                                                  formatExpirationDate(
                                                                    e.target.value
                                                                  )
                                                                )
                                                              }
                                                              placeholder="Validade"
                                                            />
                                                            <Label className="segundaCol">
                                                              Validade
                                                            </Label>
                                                          </FormGroup>
                                                        </div>
                                                        <div className="cardGroup">
                                                          <FormGroup className="menorCampo">
                                                            {errors.cvc &&
                                                              touched.cvc ? (
                                                              <FieldErrorMessage>
                                                                {errors.cvc}
                                                              </FieldErrorMessage>
                                                            ) : null}

                                                            <InputField
                                                              invalid={
                                                                pagarComCartao &&
                                                                errors.cvc &&
                                                                touched.cvc
                                                              }
                                                              id="cvc"
                                                              type="text"
                                                              name="cvc"
                                                              onBlur={handleBlur}
                                                              onFocus={
                                                                handleInputFocus
                                                              }
                                                              value={values.cvc}
                                                              pattern="\d{3,4}"
                                                              onChange={(e) =>
                                                                setFieldValue(
                                                                  "cvc",
                                                                  formatCVC(
                                                                    e.target.value
                                                                  )
                                                                )
                                                              }
                                                              placeholder="CVV"
                                                            />
                                                            <Label>
                                                              {
                                                                "Código de segurança (CVV)"
                                                              }
                                                            </Label>
                                                          </FormGroup>
                                                          <FormGroup>
                                                            {total &&
                                                              defaultValueInstallment && (
                                                                <Select
                                                                  name="installments"
                                                                  defaultValue={
                                                                    defaultValueInstallment
                                                                  }
                                                                  isSearchable={
                                                                    false
                                                                  }
                                                                  placeholder="Número de parcelas"
                                                                  options={
                                                                    optionsInstallments
                                                                  }
                                                                  className="combobox segundaCol"
                                                                  menuPlacement="top"
                                                                  styles={{
                                                                    menuList: (provided) => ({
                                                                      ...provided,
                                                                      backgroundColor: "var(--neutral-0, #fdfdfd)",
                                                                      border: "1px solid var(--primary-500, #143C97)",
                                                                    }),
                                                                    control: (provided, state) => ({
                                                                      ...provided,
                                                                      borderRadius: 8,
                                                                      borderColor: state.isFocused ? "var(--primary-500, #143C97)" : "var(--neutral-200, #D0D1D3)",
                                                                      boxShadow: "none",
                                                                    }),
                                                                  }}
                                                                  menuIsOpen={
                                                                    optionsInstallments.length <=
                                                                    1
                                                                      ? false
                                                                      : undefined
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    setFieldValue(
                                                                      "installments",
                                                                      e.value
                                                                    );
                                                                  }}
                                                                />
                                                              )}
                                                            <Label className="segundaCol">
                                                              Número de parcelas
                                                            </Label>
                                                          </FormGroup>
                                                        </div>
                                                      </div>
                                                    </>
                                                  )}
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      )
                                    )}
                                  </RadioConteinerGroup>
                                  )}
                                </Form>
                                <ButtonFooterWrap
                                  style={{ display: "none" }}
                                  id="button-finalizar-pagamento"
                                  disabled={loading}
                                  type="submit"
                                  form="payment-form"
                                >
                                  {loading ? (
                                    <>
                                      <Loader
                                        type="Oval"
                                        color="#FFFFFF"
                                        height={16}
                                        width={16}
                                      />{" "}
                                      {loadingButtonText}
                                    </>
                                  ) : (
                                    buttonText
                                  )}
                                </ButtonFooterWrap>
                              </>
                            )
                          }
                        </Formik>
                      </>
                    )}
                  {(!pagarComCartao ||
                    deliveryData?.lojaSelecionada?.formaPagamento.online
                      .length === 0) &&
                    deliveryData?.lojaSelecionada?.formaPagamento.presencial
                      .length > 0 && (
                      <>
                        <Formik
                          initialValues={{
                            paymentPlace: "P",
                            paymentMode: "",
                            paymentValue: "",
                            clientNameCE: "",
                            phoneCE: "",
                            companyName: "",
                            clientNameCV: "",
                            phoneCV: "",
                          }}
                          validate={(values) => { }}
                          validationSchema={PaymentSchema}
                          onSubmit={(values) => {
                            dispatch(OrderActions.orderRequest(values));
                          }}
                        >
                          {({
                            values,
                            handleChange,
                            handleBlur,
                            errors,
                            touched,
                            handleSubmit,
                            handleReset,
                            setFieldValue,
                            isSubmitting,
                            isValid,
                          }) =>
                            deliveryData &&
                            deliveryData?.lojaSelecionada?.formaPagamento
                              .presencial.length > 0 && (
                              <>
                                <Form id="payment-form" onSubmit={handleSubmit}>
                                  <div
                                    className={`payment-form-type pag-local`}
                                  >
                                    {/* <h1>Trabalhamos com várias formas de pagamento</h1> */}
                                    <RadioConteinerGroup>
                                      {deliveryData?.lojaSelecionada?.formaPagamento.presencial.map(
                                        (payment) => (
                                          <>
                                            {payment.tipo === "PI" && (
                                              <>
                                                <div
                                                  key={payment.tipo}
                                                  id="pagamento-pix"
                                                  className={
                                                    values.paymentMode === "PI"
                                                      ? "radio selected"
                                                      : "radio"
                                                  }
                                                >
                                                  <RadioSelectPayment>
                                                    <input
                                                      className=""
                                                      id="radio-1"
                                                      value="PI"
                                                      onChange={(e) => {
                                                        handleReset();
                                                        handleChange(e);
                                                        setPaymentMode("PI");
                                                        setFieldValue(
                                                          "paymentPercDiscount",
                                                          payment.perc_desconto
                                                        );
                                                      }}
                                                      onBlur={handleBlur}
                                                      name="paymentMode"
                                                      type="radio"
                                                      checked={
                                                        values.paymentMode ===
                                                          "PI"
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    <label
                                                      htmlFor="radio-1"
                                                      className="radio-label"
                                                    >
                                                      <IconBadge><FiZap size={18} /></IconBadge>
                                                      PIX
                                                    </label>
                                                    {Number(payment.perc_desconto) > 0 && (
                                                        <label className="labelDiscount">
                                                          {
                                                            payment.perc_desconto
                                                          }{" "}
                                                          % de desconto
                                                        </label>
                                                      )}
                                                  </RadioSelectPayment>
                                                </div>
                                              </>
                                            )}

                                            {payment.tipo === "DI" && (
                                              <>
                                                <div
                                                  key={payment.tipo}
                                                  id="pagamento-dinheiro"
                                                  className={
                                                    values.paymentMode === "DI"
                                                      ? "radio selected"
                                                      : "radio"
                                                  }
                                                >
                                                  <RadioSelectPayment>
                                                    <input
                                                      id="radio-2"
                                                      value="DI"
                                                      onChange={(e) => {
                                                        handleReset();
                                                        handleChange(e);
                                                        setPaymentMode("DI");
                                                        setFieldValue(
                                                          "paymentPercDiscount",
                                                          payment.perc_desconto
                                                        );
                                                      }}
                                                      onBlur={handleBlur}
                                                      name="paymentMode"
                                                      type="radio"
                                                      checked={
                                                        values.paymentMode ===
                                                          "DI"
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    <label
                                                      htmlFor="radio-2"
                                                      className="radio-label"
                                                    >
                                                      <IconBadge><FiDollarSign size={18} /></IconBadge>
                                                      Dinheiro
                                                    </label>
                                                    {Number(payment.perc_desconto) > 0 && (
                                                        <label className="labelDiscount">
                                                          {
                                                            payment.perc_desconto
                                                          }{" "}
                                                          % de desconto
                                                        </label>
                                                      )}
                                                  </RadioSelectPayment>
                                                  {values.paymentMode ===
                                                    "DI" && (
                                                      <>
                                                        <span>
                                                          Precisa de troco? Digite
                                                          o valor que você vai
                                                          pagar em dinheiro.
                                                        </span>
                                                        {errors.paymentValue &&
                                                          touched.paymentValue ? (
                                                          <FieldErrorMessage>
                                                            {errors.paymentValue}
                                                          </FieldErrorMessage>
                                                        ) : null}
                                                        <div className="textLine">
                                                          <div className="textArea">
                                                            <span>
                                                              Informe o valor:
                                                            </span>
                                                            <InputField
                                                              id="paymentValue"
                                                              placeholder="Ex: R$ 000,00"
                                                              name="paymentValue"
                                                              invalid={
                                                                errors.paymentValue &&
                                                                touched.paymentValue
                                                              }
                                                              onChange={
                                                                handleChange
                                                              }
                                                              onBlur={(e) => {
                                                                const formattedValue =
                                                                  e.target
                                                                    .value !== ""
                                                                    ? formatPrice(
                                                                      e.target.value
                                                                        .replace(
                                                                          ",",
                                                                          "."
                                                                        )
                                                                        .replace(
                                                                          /[^0-9\.]/g,
                                                                          ""
                                                                        )
                                                                    )
                                                                    : "";
                                                                setFieldValue(
                                                                  "paymentValue",
                                                                  formattedValue
                                                                );
                                                              }}
                                                              value={
                                                                values.paymentValue
                                                              }
                                                            />
                                                          </div>
                                                        </div>
                                                      </>
                                                    )}
                                                </div>
                                              </>
                                            )}

                                            {payment.tipo === "CR" && (
                                              <>
                                                <div
                                                  key={payment.tipo}
                                                  id="pagamento-credito"
                                                  className={
                                                    values.paymentMode === "CR"
                                                      ? "radio selected"
                                                      : "radio"
                                                  }
                                                >
                                                  <RadioSelectPayment>
                                                    <input
                                                      id="radio-3"
                                                      value="CR"
                                                      onChange={(e) => {
                                                        handleReset();
                                                        handleChange(e);
                                                        setPaymentMode("CR");
                                                        setFieldValue(
                                                          "paymentPercDiscount",
                                                          payment.perc_desconto
                                                        );
                                                      }}
                                                      onBlur={handleBlur}
                                                      name="paymentMode"
                                                      type="radio"
                                                      checked={
                                                        values.paymentMode ===
                                                          "CR"
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    <label
                                                      htmlFor="radio-3"
                                                      className="radio-label"
                                                    >
                                                      <IconBadge><FiCreditCard size={18} /></IconBadge>
                                                      Cartão de Crédito
                                                    </label>
                                                    {Number(payment.perc_desconto) > 0 && (
                                                        <label className="labelDiscount">
                                                          {
                                                            payment.perc_desconto
                                                          }{" "}
                                                          % de desconto
                                                        </label>
                                                      )}
                                                  </RadioSelectPayment>
                                                </div>
                                              </>
                                            )}

                                            {payment.tipo === "CD" && (
                                              <>
                                                <div
                                                  key={payment.tipo}
                                                  id="pagamento-debito"
                                                  className={
                                                    values.paymentMode === "CD"
                                                      ? "radio selected"
                                                      : "radio"
                                                  }
                                                >
                                                  <RadioSelectPayment>
                                                    <input
                                                      id="radio-4"
                                                      value="CD"
                                                      onChange={(e) => {
                                                        handleReset();
                                                        handleChange(e);
                                                        setPaymentMode("CD");
                                                        setFieldValue(
                                                          "paymentPercDiscount",
                                                          payment.perc_desconto
                                                        );
                                                      }}
                                                      onBlur={handleBlur}
                                                      name="paymentMode"
                                                      type="radio"
                                                      checked={
                                                        values.paymentMode ===
                                                          "CD"
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    <label
                                                      htmlFor="radio-4"
                                                      className="radio-label"
                                                    >
                                                      <IconBadge><FiCreditCard size={18} /></IconBadge>
                                                      Cartão de Débito
                                                    </label>
                                                    {Number(payment.perc_desconto) > 0 && (
                                                        <label className="labelDiscount">
                                                          {
                                                            payment.perc_desconto
                                                          }{" "}
                                                          % de desconto
                                                        </label>
                                                      )}
                                                  </RadioSelectPayment>
                                                </div>
                                              </>
                                            )}

                                            {payment.tipo === "CE" && (
                                              <>
                                                <div
                                                  key={payment.tipo}
                                                  id="pagamento-crediario"
                                                  className={
                                                    values.paymentMode === "CE"
                                                      ? "radio selected"
                                                      : "radio"
                                                  }
                                                >
                                                  <RadioSelectPayment>
                                                    <input
                                                      id="radio-5"
                                                      value="CE"
                                                      onChange={(e) => {
                                                        handleReset();
                                                        handleChange(e);
                                                        setPaymentMode("CE");
                                                        setFieldValue(
                                                          "paymentPercDiscount",
                                                          payment.perc_desconto
                                                        );
                                                      }}
                                                      onBlur={handleBlur}
                                                      name="paymentMode"
                                                      type="radio"
                                                      checked={
                                                        values.paymentMode ===
                                                          "CE"
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    <label
                                                      htmlFor="radio-5"
                                                      className="radio-label"
                                                    >
                                                      <IconBadge><FiRepeat size={18} /></IconBadge>
                                                      Crediário
                                                    </label>
                                                    {Number(payment.perc_desconto) > 0 && (
                                                        <label className="labelDiscount">
                                                          {
                                                            payment.perc_desconto
                                                          }{" "}
                                                          % de desconto
                                                        </label>
                                                      )}
                                                  </RadioSelectPayment>
                                                  {values.paymentMode ===
                                                    "CE" && (
                                                      <>
                                                        <span
                                                          style={{
                                                            display:
                                                              values.paymentMode ===
                                                                "CE"
                                                                ? "block"
                                                                : "none",
                                                          }}
                                                        >
                                                          Disponível apenas para
                                                          clientes já cadastrados,
                                                          com limite disponível e
                                                          apresentação de
                                                          documento de
                                                          identificação.
                                                        </span>
                                                        <div
                                                          style={{
                                                            display:
                                                              values.paymentMode ===
                                                                "CE"
                                                                ? "block"
                                                                : "none",
                                                            width: "100%",
                                                          }}
                                                        >
                                                          {values.paymentMode ===
                                                            "CE" &&
                                                            errors.clientNameCE &&
                                                            touched.clientNameCE ? (
                                                            <FieldErrorMessage>
                                                              {
                                                                errors.clientNameCE
                                                              }
                                                            </FieldErrorMessage>
                                                          ) : null}
                                                          {values.paymentMode ===
                                                            "CE" &&
                                                            errors.phoneCE &&
                                                            touched.phoneCE ? (
                                                            <FieldErrorMessage>
                                                              {errors.phoneCE}
                                                            </FieldErrorMessage>
                                                          ) : null}
                                                          <div className="textLine">
                                                            <div className="textArea">
                                                              <span>Nome:</span>
                                                              <InputField
                                                                id="clientNameCE"
                                                                invalid={
                                                                  values.paymentMode ===
                                                                  "CE" &&
                                                                  errors.clientNameCE &&
                                                                  touched.clientNameCE
                                                                }
                                                                placeholder="Nome e sobrenome do cliente"
                                                                name="clientNameCE"
                                                                onChange={
                                                                  handleChange
                                                                }
                                                                onBlur={
                                                                  handleBlur
                                                                }
                                                                disabled={
                                                                  values.paymentMode ===
                                                                    "CE"
                                                                    ? false
                                                                    : true
                                                                }
                                                              />
                                                            </div>
                                                            <div className="textArea">
                                                              <span
                                                                style={{
                                                                  paddingLeft:
                                                                    "0",
                                                                }}
                                                              >
                                                                Telefone:
                                                              </span>
                                                              <MaskedInput
                                                                mask={phoneMask}
                                                                invalid={
                                                                  values.paymentMode ===
                                                                  "CE" &&
                                                                  errors.phoneCE &&
                                                                  touched.phoneCE
                                                                }
                                                                id="phoneCE"
                                                                placeholder="Ex: (00) 0000-0000"
                                                                name="phoneCE"
                                                                onChange={
                                                                  handleChange
                                                                }
                                                                onBlur={
                                                                  handleBlur
                                                                }
                                                                render={(
                                                                  ref,
                                                                  props
                                                                ) => (
                                                                  <InputField
                                                                    ref={(
                                                                      input
                                                                    ) =>
                                                                      ref(input)
                                                                    }
                                                                    {...props}
                                                                  />
                                                                )}
                                                                disabled={
                                                                  values.paymentMode ===
                                                                    "CE"
                                                                    ? false
                                                                    : true
                                                                }
                                                              />
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </>
                                                    )}
                                                </div>
                                              </>
                                            )}

                                            {payment.tipo === "CV" && (
                                              <>
                                                <div
                                                  key={payment.tipo}
                                                  id="pagamento-convenio"
                                                  className={
                                                    values.paymentMode === "CV"
                                                      ? "radio selected"
                                                      : "radio"
                                                  }
                                                >
                                                  <RadioSelectPayment>
                                                    <input
                                                      id="radio-6"
                                                      value="CV"
                                                      onChange={(e) => {
                                                        handleReset();
                                                        handleChange(e);
                                                        setPaymentMode("CV");
                                                        setFieldValue(
                                                          "paymentPercDiscount",
                                                          payment.perc_desconto
                                                        );
                                                      }}
                                                      onBlur={handleBlur}
                                                      name="paymentMode"
                                                      type="radio"
                                                      checked={
                                                        values.paymentMode ===
                                                          "CV"
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    <label
                                                      htmlFor="radio-6"
                                                      className="radio-label"
                                                    >
                                                      <IconBadge><FiFileText size={18} /></IconBadge>
                                                      Convênio
                                                    </label>
                                                    {Number(payment.perc_desconto) > 0 && (
                                                        <label className="labelDiscount">
                                                          {
                                                            payment.perc_desconto
                                                          }{" "}
                                                          % de desconto
                                                        </label>
                                                      )}
                                                  </RadioSelectPayment>
                                                  {values.paymentMode ===
                                                    "CV" && (
                                                      <>
                                                        <span
                                                          style={{
                                                            display:
                                                              values.paymentMode ===
                                                                "CV"
                                                                ? "block"
                                                                : "none",
                                                          }}
                                                        >
                                                          Disponível apenas para
                                                          clientes já cadastrados,
                                                          com limite disponível e
                                                          apresentação de
                                                          documento de
                                                          identificação.
                                                        </span>
                                                        <div
                                                          style={{
                                                            display:
                                                              values.paymentMode ===
                                                                "CV"
                                                                ? "block"
                                                                : "none",
                                                            width: "100%",
                                                          }}
                                                        >
                                                          <div className="textLine">
                                                            <div className="textArea">
                                                              {values.paymentMode ===
                                                                "CV" &&
                                                                errors.companyName &&
                                                                touched.companyName ? (
                                                                <FieldErrorMessage>
                                                                  {
                                                                    errors.companyName
                                                                  }
                                                                </FieldErrorMessage>
                                                              ) : null}
                                                              <span>
                                                                Nome do convênio
                                                              </span>
                                                              <InputField
                                                                id="companyName"
                                                                invalid={
                                                                  values.paymentMode ===
                                                                  "CV" &&
                                                                  errors.companyName &&
                                                                  touched.companyName
                                                                }
                                                                placeholder="Nome da empresa do convênio"
                                                                name="companyName"
                                                                onChange={
                                                                  handleChange
                                                                }
                                                                onBlur={
                                                                  handleBlur
                                                                }
                                                                disabled={
                                                                  values.paymentMode ===
                                                                    "CV"
                                                                    ? false
                                                                    : true
                                                                }
                                                              />
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div
                                                          style={{
                                                            display:
                                                              values.paymentMode ===
                                                                "CV"
                                                                ? "block"
                                                                : "none",
                                                            width: "100%",
                                                          }}
                                                        >
                                                          <div className="textLine">
                                                            <div className="textArea">
                                                              {values.paymentMode ===
                                                                "CV" &&
                                                                errors.clientNameCV &&
                                                                touched.clientNameCV ? (
                                                                <FieldErrorMessage>
                                                                  {
                                                                    errors.clientNameCV
                                                                  }
                                                                </FieldErrorMessage>
                                                              ) : null}
                                                              <InputField
                                                                id="clientNameCV"
                                                                invalid={
                                                                  values.paymentMode ===
                                                                  "CV" &&
                                                                  errors.clientNameCV &&
                                                                  touched.clientNameCV
                                                                }
                                                                placeholder="Nome completo do cliente"
                                                                name="clientNameCV"
                                                                onChange={
                                                                  handleChange
                                                                }
                                                                onBlur={
                                                                  handleBlur
                                                                }
                                                                disabled={
                                                                  values.paymentMode ===
                                                                    "CV"
                                                                    ? false
                                                                    : true
                                                                }
                                                              />
                                                            </div>
                                                            <div className="textArea">
                                                              {values.paymentMode ===
                                                                "CV" &&
                                                                errors.phoneCV &&
                                                                touched.phoneCV ? (
                                                                <FieldErrorMessage>
                                                                  {errors.phoneCV}
                                                                </FieldErrorMessage>
                                                              ) : null}
                                                              <span
                                                                style={{
                                                                  paddingLeft:
                                                                    "0",
                                                                }}
                                                              >
                                                                Telefone
                                                              </span>
                                                              <MaskedInput
                                                                mask={phoneMask}
                                                                invalid={
                                                                  values.paymentMode ===
                                                                  "CV" &&
                                                                  errors.phoneCV &&
                                                                  touched.phoneCV
                                                                }
                                                                id="phoneCV"
                                                                placeholder="Ex: (00) 0000-0000"
                                                                name="phoneCV"
                                                                onChange={
                                                                  handleChange
                                                                }
                                                                onBlur={
                                                                  handleBlur
                                                                }
                                                                render={(
                                                                  ref,
                                                                  props
                                                                ) => (
                                                                  <InputField
                                                                    ref={(
                                                                      input
                                                                    ) =>
                                                                      ref(input)
                                                                    }
                                                                    {...props}
                                                                  />
                                                                )}
                                                                disabled={
                                                                  values.paymentMode ===
                                                                    "CV"
                                                                    ? false
                                                                    : true
                                                                }
                                                              />
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </>
                                                    )}
                                                </div>
                                              </>
                                            )}
                                          </>
                                        )
                                      )}
                                    </RadioConteinerGroup>
                                  </div>
                                </Form>
                                <ButtonFooterWrap
                                  style={{ display: "none" }}
                                  id="button-finalizar-pagamento"
                                  disabled={loading}
                                  type="submit"
                                  form="payment-form"
                                >
                                  {loading ? (
                                    <>
                                      <Loader
                                        type="Oval"
                                        color="#FFFFFF"
                                        height={16}
                                        width={16}
                                      />{" "}
                                      {loadingButtonText}
                                    </>
                                  ) : (
                                    buttonText
                                  )}
                                </ButtonFooterWrap>
                              </>
                            )
                          }
                        </Formik>
                      </>
                    )}
                </PaymentDetails>
              </PaymentContainer>
               <DivBadgeStyled>
                  <BadgePaymentProvider
                    provedor_pagamento_badge={
                      storeData?.empresa?.provedor_pagamento_badge
                    }
                    provedor_pgto_badge_ref={
                      storeData?.empresa?.provedor_pgto_badge_ref
                    }
                  />
                </DivBadgeStyled>
            </Wrap>
            <PriceInfoWrap>
              <TitleWrap>Resumo do Pedido</TitleWrap>
              <PriceInfoContent>
                <span className="price-description">
                  Subtotal ({textoQuantidadeProdutos(distinctProductsIdCount)})
                </span>
                <span className="price-value">{formatPrice(subtotal)}</span>
              </PriceInfoContent>

              {regraFreteGratis?.ativo &&
                deliveryData?.tipoEntrega === "RECEBER_EM_CASA" && (
                <FreeShippingProgress
                  valorMinimo={parseFloat(regraFreteGratis.valorMinimo)}
                  base={baseFreteGratis}
                />
              )}

              <StyledCouponInput
                id="cupom"
                ref={inputCouponRef}
                textTransform="uppercase"
                type="apply"
                name="cupom"
                placeholder="Seu cupom"
                description="Você possui um CUPOM de desconto?"
                autoComplete="off"
                onClickSpan={verifyCoupon}
                defaultValue={basket?.cupom?.nome || ""}
              />
              {showCouponError !== null && (
                <CouponErrorMessage>
                  {ReactHtmlParser(showCouponError)}
                </CouponErrorMessage>
              )}
              {subtotal - total > 0 && (
                <PriceInfoContent className="discount">
                  <span className="price-description">Descontos</span>
                  <span className="price-value">
                    - {formatPrice(subtotal - total)}
                  </span>
                </PriceInfoContent>
              )}

              {coupon !== null && (
                <PriceInfoContent>
                  <span className="price-description coupon-discount">
                    Desconto do cupom
                  </span>
                  <span className="price-value coupon-discount">
                    - {formatPrice(couponDiscount)}
                  </span>
                </PriceInfoContent>
              )}

              {getDescontoPagamento() > 0 && (
                <PriceInfoContent className="payment-discount">
                  <span className="price-description">
                    Desconto{" "}
                    {NOMES_PAGAMENTO[paymentMode] || "forma de pagamento"}
                  </span>
                  <span className="price-value payment-discount">
                    - {formatPrice(getDescontoPagamento())}
                  </span>
                </PriceInfoContent>
              )}

              {deliveryData?.lojaSelecionada !== null &&
                deliveryData?.tipoEntrega === "RECEBER_EM_CASA" && (
                  <PriceInfoContent className="delivery-fee">
                    <span className="price-description">Taxa de entrega</span>
                    <span className="price-value">
                      {freteGratisAplicado ? (
                        <>
                          <span style={{ textDecoration: "line-through" }}>
                            +{" "}
                            {formatPrice(
                              getDeliveryTotal(deliveryData)
                            )}
                          </span>
                        </>
                      ) : (
                        <>
                          +{" "}
                          {formatPrice(
                            getDeliveryTotal(deliveryData)
                          )}
                        </>
                      )}
                    </span>
                  </PriceInfoContent>
                )}

              <OrderMinimumNotice valorMinimo={valorMinimoPedido} base={baseMinimoPedido} comDesconto={descontoCupomMercadoria > 0} />

              <PriceInfoContent className="total">
                <span className="price-description total">Total</span>
                <span className="price-value total">
                  {formatPrice(calculateTotal())}
                </span>
              </PriceInfoContent>

              <ButtonFooterWrap
                id="button-finalizar-pagamento"
                form="payment-form"
                disabled={paymentMode === "" || abaixoPedidoMinimo || (pagarComCartao && abaixoPisoOnline())}
                type="submit"
              >
                Finalizar pedido
              </ButtonFooterWrap>

              <CollapseList items={cart.data?.itens} customerHasFacilityProgram={programa_fidelidade} />
            </PriceInfoWrap>
          </ContentWrap>
          <ModalConfirm
            message={orderConfirmationMessage}
            visible={showConfirmOrderModal}
            confirm={() => dispatch(OrderActions.confirmOrderRequest(true))}
            cancel={() => dispatch(OrderActions.hideConfirmOrderModal())}
          />
        </Container>
        {loading && (
          <LoadingOverlay dialogMessage={loadingButtonText} />
        )}
      </CheckoutPage>
    </BuyStepsTemplate>
  );
}
